import * as FullStory from '@fullstory/browser';

FullStory.init({
    orgId: 'HM01P',
    devMode: process.env.NODE_ENV !== 'production',
});

export default FullStory;